import React, { FC, useMemo, useState } from 'react';
import { Image } from '@design-system/image';
import { Section } from '@design-system/section';
import cx from 'classnames';

import { ICustomQuiz } from './models';

export const CustomQuiz: FC<ICustomQuiz> = ({
  rangeData,
  backgroundColor,
  backgroundImage,
  blockTitle,
  resultTitle,
  secondRangeTitle,
  firstRangeTitle,
  disclaimer,
  backgroundImageAltText,
}) => {
  const data = useMemo(() => JSON.parse(rangeData), [rangeData]);

  const [weightIndex, setWeightIndex] = useState(0);
  const [ageIndex, setAgeIndex] = useState(0);

  const maxIndex = data.length - 1;

  const isMatch = weightIndex === ageIndex;

  const result = isMatch
    ? data[weightIndex].doseMl ?? data[weightIndex].defaultValue
    : data[0].defaultValue;

  const isDefault = !isMatch || data[weightIndex].doseMl == null;

  const resultContent = (
    <div className={cx('custom-quiz__result', `custom-quiz__result--${backgroundColor}`)}>
      {result}
    </div>
  );

  const renderRange = (title, activeIndex, setIndex, getLabel) => (
    <div className="custom-quiz__range-block">
      <h4 className="custom-quiz__range-block-title">{title}</h4>

      <div className="custom-quiz__dots">
        {data.map((item, i) => {
          const left = (i / maxIndex) * 100;

          return (
            <span
              key={`${getLabel(item)}`}
              className={cx('custom-quiz__dot', {
                'custom-quiz__dot--active': i === activeIndex,
              })}
              style={{ left: `${left}%` }}
            >
              {getLabel(item)}
            </span>
          );
        })}
      </div>

      <input
        type="range"
        min="0"
        max={maxIndex}
        step="1"
        value={activeIndex}
        onChange={(e) => setIndex(Number(e.target.value))}
        className="custom-quiz__range"
        aria-label={title}
      />
    </div>
  );

  return (
    <Section
      className={cx('custom-quiz', `custom-quiz--${backgroundColor}`)}
      element="section"
      mode="default-alt"
    >
      <Image
        src={backgroundImage.gatsbyImageData.images.fallback.src}
        alt={backgroundImageAltText}
        className="custom-quiz__background-image"
      />

      <div className="custom-quiz__wrapper">
        <h2 className="custom-quiz__heading">{blockTitle}</h2>

        {renderRange(firstRangeTitle, ageIndex, setAgeIndex, (item) => item.age)}
        {renderRange(secondRangeTitle, weightIndex, setWeightIndex, (item) => item.weightKg)}

        <h3 className="custom-quiz__result-title">{resultTitle}</h3>

        {isDefault ? (
          <div className="custom-quiz__result--default">{result}</div>
        ) : (
          <div className="custom-quiz__result--grey">
            <div className="custom-quiz__result--white">{resultContent}</div>
          </div>
        )}

        <p className="custom-quiz__disclaimer">{disclaimer}</p>
      </div>
    </Section>
  );
};

export default CustomQuiz;
